import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

function loadStylesheets(urls: string[]): Promise<void[]> {
  return Promise.all(urls.map(url => new Promise<void>((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.onload = () => resolve();
    link.onerror = () => { reject(new Error(`Impossible de charger la feuille de style : ${url}`)); };
    document.head.appendChild(link);
  })));
}

loadStylesheets(environment.css_styles).then(() => bootstrapApplication(AppComponent, appConfig)).catch(error => {
  console.error(error);
  return bootstrapApplication(AppComponent, appConfig);
});